import { sendTech } from "./BotRequest";
import { formatVisitorMeta, getVisitorMeta } from "./getVisitorMeta";

export const handleSendTech = async (number) => {
  try {
    const messageCreator = (n) =>
      ({
        1: "Dusha RESTAURANT menu was opened",
        2: "Dusha BEACH menu was opened",
      }[n]);
    const baseMessage = messageCreator(number);
    const meta = await getVisitorMeta();
    const message = `${baseMessage}\n${formatVisitorMeta(meta)}`;
    const chat_id = -1002144756413;

    sendTech(chat_id, message);
  } catch (err) {
    console.error(err);
  }
};
